// See https://github.com/primefaces/primelocale/blob/main/sk.json

export default {
  accept: 'Áno',
  addRule: 'Pridať pravidlo',
  am: 'ráno',
  apply: 'Použiť',
  cancel: 'Zrušiť',
  choose: 'Vybrať',
  chooseDate: 'Vyberte dátum',
  chooseMonth: 'Vyberte mesiac',
  chooseYear: 'Vyberte rok',
  clear: 'Vyčistiť',
  completed: 'Dokončené',
  contains: 'Obsahuje',
  custom: 'Vlastné',
  dateAfter: 'Dátum je po',
  dateBefore: 'Dátum je pred',
  dateFormat: 'dd.mm.yy',
  dateIs: 'Dátum je',
  dateIsNot: 'Dátum nie je',
  dayNames: [
    'Nedeľa',
    'Pondelok',
    'Utorok',
    'Streda',
    'Štvrtok',
    'Piatok',
    'Sobota',
  ],
  dayNamesMin: [
    'Ne',
    'Po',
    'Ut',
    'St',
    'Št',
    'Pi',
    'So',
  ],
  dayNamesShort: [
    'Ned',
    'Pon',
    'Uto',
    'Str',
    'Štv',
    'Pia',
    'Sob',
  ],
  emptyFilterMessage: 'Neboli nájdené žiadne výsledky',
  emptyMessage: 'Žiadne dostupné možnosti',
  emptySearchMessage: 'Neboli nájdené žiadne výsledky',
  emptySelectionMessage: 'Žiadna vybraná položka',
  endsWith: 'Končí na',
  equals: 'Rovná sa',
  fileChosenMessage: 'Počet súborov: {0}',
  fileSizeTypes: [
    'B',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB',
  ],
  filter: 'Filter',
  firstDayOfWeek: 1,
  gt: 'Väčšie než',
  gte: 'Väčšie než alebo rovné',
  lt: 'Menšie než',
  lte: 'Menšie než alebo rovné',
  matchAll: 'Zodpovedá všetkým',
  matchAny: 'Zodpovedá akémukoľvek',
  medium: 'Stredné',
  monthNames: [
    'Január',
    'Február',
    'Marec',
    'Apríl',
    'Máj',
    'Jún',
    'Júl',
    'August',
    'September',
    'Október',
    'November',
    'December',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Máj',
    'Jún',
    'Júl',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec',
  ],
  nextDecade: 'Nasledujúce desaťročie',
  nextHour: 'Nasledujúca hodina',
  nextMinute: 'Nasledujúca minúta',
  nextMonth: 'Nasledujúci mesiac',
  nextSecond: 'Nasledujúca sekunda',
  nextYear: 'Nasledujúci rok',
  noFileChosenMessage: 'Nie je vybraný žiadny súbor',
  noFilter: 'Bez filtra',
  notContains: 'Neobsahuje',
  notEquals: 'Nerovná sa',
  now: 'Teraz',
  passwordPrompt: 'Zadejte heslo',
  pending: 'Čakajúce',
  pm: 'popoludní',
  prevDecade: 'Predchádzajúce desaťročie',
  prevHour: 'Predchádzajúca hodina',
  prevMinute: 'Predchádzajúca minúta',
  prevMonth: 'Predchádzajúci mesiac',
  prevSecond: 'Predchádzajúca sekunda',
  prevYear: 'Predchádzajúci rok',
  reject: 'Nie',
  removeRule: 'Odstrániť pravidlo',
  searchMessage: 'Je k dispozícií {0} výsledkov',
  selectionMessage: 'Vybraných {0} položiek',
  showMonthAfterYear: false,
  startsWith: 'Začína na',
  strong: 'Silné',
  today: 'Dnes',
  upload: 'Nahrať súbor',
  weak: 'Slabé',
  weekHeader: 'Týž.',
  aria: {
    cancelEdit: 'Zrušiť úpravu',
    close: 'Zavrieť',
    collapseLabel: 'kolaps',
    collapseRow: 'Zbaliť riadok',
    editRow: 'Upraviť riadok',
    expandLabel: 'Rozbaliť',
    expandRow: 'Rozbaliť riadok',
    falseLabel: 'Nepravda',
    filterConstraint: 'Obmedzenie filtra',
    filterOperator: 'Operátor filtra',
    firstPageLabel: 'Prvá strana',
    gridView: 'Zobrazenie mriežky',
    hideFilterMenu: 'Skryť filter menu',
    jumpToPageDropdownLabel: 'Prejsť na stránku Dropdown',
    jumpToPageInputLabel: 'Prejsť na stránku Input',
    lastPageLabel: 'Posledná strana',
    listLabel: 'Zoznam možností',
    listView: 'Zobrazenie zoznamu',
    maximizeLabel: 'Maximalizovať',
    minimizeLabel: 'Minimalizovať',
    moveAllToSource: 'Presunúť všetko ku zdroju',
    moveAllToTarget: 'Presunúť všetko na cieľ',
    moveBottom: 'Presunúť dole',
    moveDown: 'Presunúť dole',
    moveTop: 'Presunúť hore',
    moveToSource: 'Presunúť ku zdroju',
    moveToTarget: 'Presunúť na cieľ',
    moveUp: 'Presunúť hore',
    navigation: 'Navigácia',
    next: 'Ďalší',
    nextPageLabel: 'Dalšia strana',
    nullLabel: 'Nevybrané',
    otpLabel: 'Zadajte jednorazový znak hesla {0}',
    pageLabel: '{page}',
    passwordHide: 'Skryť heslo',
    passwordShow: 'Ukázať heslo',
    previous: 'Predchádzajúci',
    prevPageLabel: 'Predchádzajúca strana',
    removeLabel: 'Odstrániť',
    rotateLeft: 'Otočiť doľava',
    rotateRight: 'Otočiť doprava',
    rowsPerPageLabel: 'Riadkov na stranu',
    saveEdit: 'Uložiť úpravu',
    scrollTop: 'Posunúť hore',
    selectAll: 'Všetky položky vybrané',
    selectColor: 'Vyberte farbu',
    selectLabel: 'Vyberte',
    selectRow: 'Vybrať riadok',
    showFilterMenu: 'Zobraziť filter menu',
    slide: 'Snímka',
    slideNumber: '{slideNumber}',
    star: '1 hviezda',
    stars: '{star} hviezd',
    trueLabel: 'Pravda',
    unselectAll: 'Všetky položky zrušené',
    unselectLabel: 'Zrušte výber',
    unselectRow: 'Zrušiť výber riadku',
    zoomImage: 'Priblížiť obrázok',
    zoomIn: 'Priblížiť',
    zoomOut: 'Oddialiť',
  },
};
